import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { Lock, Eye, EyeOff } from 'lucide-react';
import { Button } from './ui/button';
import { Input } from './ui/input';

const SITE_PASSWORD = 'Cryppy2025!';

const PasswordGate = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const auth = localStorage.getItem('site_access');
    if (auth === 'granted') {
      setIsAuthenticated(true);
    }
    setLoading(false);
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (password === SITE_PASSWORD) {
      localStorage.setItem('site_access', 'granted');
      setIsAuthenticated(true);
      setError('');
    } else {
      setError('Incorrect password');
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-[#030014] flex items-center justify-center">
        <div className="text-white">Loading...</div>
      </div>
    );
  }

  if (isAuthenticated) {
    return children;
  }

  return (
    <div className="min-h-screen bg-[#030014] relative overflow-hidden flex items-center justify-center">
      <div className="absolute inset-0 dark-mesh" />
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-[#7000FF] opacity-20 blur-[120px] rounded-full" />
      
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="relative z-10 w-full max-w-md px-6"
      >
        <div className="text-center mb-8">
          <div className="w-20 h-20 rounded-full bg-[#7000FF]/20 flex items-center justify-center mx-auto mb-4">
            <Lock className="w-10 h-10 text-[#7000FF]" />
          </div>
          <h1 className="text-3xl font-primary font-bold text-white mb-2">CRYPPY</h1>
          <p className="text-gray-400 font-secondary">This site is currently in development</p>
        </div>

        <div className="glass-card p-8 rounded-2xl">
          <h2 className="text-xl font-primary font-bold text-white mb-6 text-center">
            AUTHORIZED ACCESS ONLY
          </h2>
          
          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <div className="relative">
                <Input
                  type={showPassword ? 'text' : 'password'}
                  placeholder="Enter access password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="bg-white/5 border-white/10 text-white placeholder:text-gray-600 focus:border-[#7000FF] pr-12"
                  data-testid="site-password-input"
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-white"
                >
                  {showPassword ? <EyeOff className="w-5 h-5" /> : <Eye className="w-5 h-5" />}
                </button>
              </div>
              {error && <p className="text-red-400 text-sm mt-2">{error}</p>}
            </div>

            <Button
              type="submit"
              className="w-full bg-[#7000FF] hover:bg-[#5B00CC] text-white rounded-full py-6 text-lg font-bold"
              data-testid="site-access-btn"
            >
              Access Site
            </Button>
          </form>

          <p className="text-gray-500 text-xs text-center mt-6">
            Contact admin for access credentials
          </p>
        </div>
      </motion.div>
    </div>
  );
};

export default PasswordGate;
